module.exports = __webpack_public_path__ + "img/icn_check_hv_kenben.e0d6b160.png";